export default __webpack_public_path__ + "static/media/trello-icon.fb227562.svg";